// chaptersData.js
export const chapters = [
  { id: 'introduction', 
    title: 'Introduction', 
    subtitle: 'Coming Soon...',
    content: ''},

  // { id: '2', title: 'Tactics Breakdown', content: '...', image: '...' },
];
